/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

// To Genarte the header of PDF
const getHeader = (currentPage, pageCount, data) => {
  const { qtr, prinDate, requestedBy, reportName, dateRange, submittedBy } =
    data;
  const header = {
    alignment: 'center',
    fontSize: 10,
    margin: [28.8, 20, 28.8, 25.92],
    style: 'tableExample',
    table: {
      headerRows: 1,
      widths: [260, 260, 250],
      body: [
        [
          {
            text: [{ text: 'Requested By: ', bold: true }, requestedBy],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: reportName,
            fontSize: 12,
            bold: true,
            fontFamily: 'arial',
            alignment: 'center',
          },
          {
            text: [{ text: 'Date Printed: ', bold: true }, prinDate],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
        [
          {
            text: '',
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: '',
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'center',
            bold: true,
          },
          {
            text: '',
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
        [
          {
            text: [
              { text: 'Submitted By: ', bold: true, fontSize: contentFont },
              { text: submittedBy, fontSize: contentFont },
            ],
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: [
              { text: 'Date Range: ', bold: true, fontSize: contentFont },
              { text: dateRange, fontSize: contentFont },
            ],

            fontFamily: 'arial',
            alignment: 'center',
          },
          {
            text: `Page ${currentPage} of ${pageCount}`,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
      ],
    },
    layout: 'noBorders',
  };
  return header;
};

const contentFont = 10;
const pageMargins = [42, 80, 28.8, 25.92];

// Function to structure the right grid table data
const getRightGridTable = (data) => {
  const dataToReturn = [];
  let totaRecordCount = 0;
  let totalReimAmount = 0;
  for (let i = 0; i < data.length; i += 1) {
    dataToReturn.push([
      {
        text: data[i].loadDate,
        fontSize: contentFont - 1,
        border: [false, false, false, false],
      },
      {
        text: data[i].prefixTag,
        fontSize: contentFont - 1,
        border: [false, false, false, false],
      },
      {
        text: data[i].descr,
        fontSize: contentFont - 1,
        border: [false, false, false, false],
      },
      {
        text: data[i].count?.toLocaleString('en-US'),
        alignment: 'right',
        fontSize: contentFont - 1,
        border: [false, false, false, false],
      },
      {
        text: data[i].reimbAmount?.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        }),
        alignment: 'right',
        fontSize: contentFont - 1,

        border: [false, false, false, false],
      },
    ]);
    totaRecordCount += data[i].count;
    totalReimAmount += data[i].reimbAmount;
  }
  dataToReturn.push([
    {
      text: 'Total:',
      bold: true,
      fontSize: contentFont,
      border: [false, true, false, false],
    },
    {
      text: '',
      bold: true,
      fontSize: contentFont,
      border: [false, true, false, false],
    },
    {
      text: '',
      bold: true,
      fontSize: contentFont - 1,
      border: [false, true, false, false],
    },
    {
      text: totaRecordCount.toLocaleString('en-US'),
      alignment: 'right',
      fontSize: contentFont,
      bold: true,
      border: [false, true, false, false],
    },

    {
      text: totalReimAmount.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      }),
      alignment: 'right',
      fontSize: contentFont,
      bold: true,
      border: [false, true, false, false],
    },
  ]);
  return dataToReturn;
};

// //Function to structure the left grid table data
const getLeftGridTable = (data) => {
  const dataToReturn = [];
  let totaRecordCount = 0;
  for (let i = 0; i < data.length; i += 1) {
    const isSubTotal = data[i]._subTotalLabelCell || data[i].isBottomRow;
    dataToReturn.push([
      {
        text: data[i].claimLoadDate || '',
        bold: isSubTotal,
        fontSize: contentFont - 1,
        border: [false, false, false, false],
      },
      {
        text: data[i].qtr || '',
        bold: isSubTotal,
        fontSize: contentFont - 1,
        border: [false, false, false, false],
      },
      {
        text: data[i].rebateProgramCd,
        bold: isSubTotal,
        fontSize: contentFont - 1,
        border: [false, false, false, false],
      },
      {
        text: data[i].recordCount?.toLocaleString('en-US') || '',
        alignment: 'right',
        bold: isSubTotal,
        fontSize: contentFont - 1,
        border: [false, false, false, false],
      },
    ]);

    if (!isSubTotal) {
      totaRecordCount += Number(data[i].recordCount) || 0;
    }
  }

  dataToReturn.push([
    {
      text: 'Total:',
      bold: true,
      fontSize: contentFont,
      border: [false, true, false, false],
    },
    {
      text: '',
      bold: true,
      fontSize: contentFont - 1,
      border: [false, true, false, false],
    },
    {
      text: '',
      bold: true,
      fontSize: contentFont,
      border: [false, true, false, false],
    },
    {
      text: totaRecordCount.toLocaleString('en-US'),
      alignment: 'right',
      fontSize: contentFont,
      bold: true,
      border: [false, true, false, false],
    },
  ]);
  return dataToReturn;
};

// Function to form complete table
const getTableBody = (data) => {
  const { leftGridData, rightGridData } = data;
  const body = [];

  body.push({
    style: 'tableExample',

    table: {
      widths: [300, 20, 580],
      body: [
        [
          {
            style: 'tableExample',
            table: {
              headerRows: 1,
              widths: [60, 60, 80, 60],
              body: [
                [
                  {
                    text: 'Load Date',
                    bold: true,
                    fontSize: contentFont,
                    border: [false, false, false, true],
                  },
                  {
                    text: 'Quarter',
                    bold: true,
                    fontSize: contentFont,
                    border: [false, false, false, true],
                  },
                  {
                    text: 'Rebate Program',
                    bold: true,
                    fontSize: contentFont,
                    border: [false, false, false, true],
                  },
                  {
                    text: 'Count',
                    alignment: 'right',
                    bold: true,
                    fontSize: contentFont,
                    border: [false, false, false, true],
                  },
                ],
                ...getLeftGridTable(leftGridData),
              ],
            },
          },
          ' ',
          {
            style: 'tableExample',
            table: {
              headerRows: 1,
              widths: [60, 45, 130, 'auto', 'auto'],
              body: [
                [
                  {
                    text: 'Load Date',
                    bold: true,
                    fontSize: contentFont,
                    border: [false, false, false, true],
                  },
                  {
                    text: 'Prefix',
                    bold: true,
                    fontSize: contentFont,
                    border: [false, false, false, true],
                  },
                  {
                    text: 'Description',
                    bold: true,
                    fontSize: contentFont,
                    border: [false, false, false, true],
                  },
                  {
                    text: 'Count',
                    alignment: 'right',
                    bold: true,
                    fontSize: contentFont,
                    border: [false, false, false, true],
                  },
                  {
                    text: 'ReimbAmount',
                    alignment: 'right',
                    bold: true,
                    fontSize: contentFont,
                    border: [false, false, false, true],
                  },
                ],
                ...getRightGridTable(rightGridData),
              ],
            },
          },
        ],
      ],
    },
    layout: 'noBorders',
  });

  return body;
};

const styles = {
  header: {
    fontSize: 18,
    bold: true,
    margin: [0, 0, 0, 10],
  },
  subheader: {
    fontSize: 16,
    bold: true,
    margin: [0, 10, 0, 5],
  },
  tableExample: {
    margin: [0, 5, 0, 15],
  },
  tableHeader: {
    bold: true,
    fontSize: 13,
    color: 'black',
  },
};

// Function to transform the data for PDF
const getPdfData = (bodyData, headerData) => {
  const content = getTableBody(bodyData);
  const currentYear = new Date().getFullYear();
  return {
    header: (currentPage, pageCount) => {
      return getHeader(currentPage, pageCount, headerData);
    },
    footer: () => {
        const footers = [];
        footers.push({
          text:`${currentYear} Conduent Business Services, LLC. All rights reserved. Conduent and Conduent Agile Star are trademarks of Conduent Business Services, LLC in the United States and/or other countries.`,
          fontSize: 8,
          color: '#636363',
          fontFamily: 'Arial',
          alignment: 'center',
        });

      return footers;
    },
    content,
    pageMargins,
    styles,
    pageOrientation: 'landscape',
  };
};

// generate PDF and download the PDF
export const exportAllData = ({
  leftGridData,
  rightGridData,
  userDefaults: UserDefaultValues,
  selectedRequest,
  logInUser,
  filename,
}) => {
  const headerData = {
    prinDate: moment(new Date()).format('MM/DD/YYYY'),
    requestedBy:
      UserDefaultValues && UserDefaultValues.userId
        ? UserDefaultValues.userId
        : logInUser,
    reportName: 'Monthly Claims Reconciliation',
    dateRange: `${selectedRequest.startDate} - ${selectedRequest.endDate}`,
    submittedBy: selectedRequest.requestorUserId,
  };
  const pdfData = getPdfData({ rightGridData, leftGridData }, headerData);
  pdfMake
    .createPdf(pdfData)
    .download(`${filename}.pdf` || 'MonthlyClaimReconciliation.pdf');
};
